<template>
  <div class="ui attached secondary segment">
    <div class="ui button group first">
      <div class="viewer-control-panel_button hover">
        <font-awesome-icon
          v-if="isDownloadingClip"
          icon="spinner"
          size="2x"
          id='loading-spinner'
          />
        <font-awesome-icon
          v-else
          icon="download"
          @click="download"
          size="2x"
          id="download"
          />
      </div>
      <div class="viewer-control-panel_button hover" v-if="isInvestigating">
        <font-awesome-layers @click="addImage" id='snapshot'>
          <font-awesome-icon
            icon="image"
            size="2x"
            />
          <font-awesome-icon
            style="color: rgba(168, 168, 168, 1)"
            icon="plus"
            :transform="plusIconTransform"
            />
        </font-awesome-layers>
      </div>
       <div class="viewer-control-panel_button hover">
        <font-awesome-icon
          icon="file-invoice"
          @click="showFormLetterPanel"
          size="2x"
          id="report-button"
          />
      </div>
      <div class="viewer-control-panel_button hover">
        <font-awesome-icon
          icon="link"
          @click="copyCurrentUrl"
          size="2x"
          id="copy-button"
          />
      </div>
    </div>
    <div class="ui button group second">
      <div v-if="!isLive" class="viewer-control-panel_button hover">
        <font-awesome-icon
          icon="backward"
          @click="back"
          size="2x"
          id="back"
          />
      </div>
      <div class="viewer-control-panel_button hover" id="play">
        <font-awesome-icon
          v-if="!isPlaying"
          icon="play"
          @click="setPlay"
          size="2x"
          />
        <font-awesome-icon
          v-else
          icon="pause"
          @click="setPlay"
          size="2x"
          />
      </div>
      <div v-if="!isLive" id="forward" class="viewer-control-panel_button hover">
        <font-awesome-icon
          icon="forward"
          @click="forward"
          size="2x"
          />
      </div>
    </div>
    <div class="ui button group third">
      <owal-speed-picker
        v-if="!isLive"
        class="owal-speed-picker hover"
        @rate-selected="handleSelection"
        />
      <div class="ui button hover">
        <font-awesome-icon
          icon="window-maximize"
          @click="setFullscreen"
          size="2x"
          id="fullscreen"
          />
      </div>
      <div class="ui button hover" :style="cameraDetections ? '' : 'display: none;'">
        <font-awesome-icon
          icon="dna"
          @click="showDNA"
          size="2x"
          id="fullscreen"
          />
      </div>
    </div>
  </div>
</template>

<script>
import OwalSpeedPicker from './OwalSpeedPicker'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'ControlPanel',
  components: { OwalSpeedPicker },
  data () {
    return {
      requestedLongClip: false,
      dna: false,
    }
  },
  computed: {
    ...mapGetters({
      isPlaying: 'viewer/isPlaying',
      isFullscreen: 'viewer/isFullscreen',
      isLive: 'viewer/isLive',
      isDownloadingClip: 'viewer/isDownloadingClip',
      isInvestigating: 'viewerTools/isInvestigating',
      cameraDetections: 'dna/cameraDetections',
    }),
    playButtonClass: function () {
      return `big ${this.isPlaying ? 'pause' : 'play'} icon`
    },
    plusIconTransform () {
      const windowSizeSM = window.matchMedia('(max-width: 450px)')
      if (windowSizeSM.matches) {
        return 'down-3 right-9 grow-0'
      } else return 'down-7.5 right-20 grow-3'
    },
  },
  methods: {
    ...mapMutations({
      updatePlaying: 'viewer/setIsPlaying',
      updateRate: 'viewer/setPlaybackRate',
      updateFullscreen: 'viewer/setFullScreen',
      showDNA: 'dna/shouldShowDetections',
    }),
    handleSelection: function (rate) {
      this.updateRate(rate)
    },
    setPlay: function () {
      this.updatePlaying(!this.isPlaying)
    },
    setFullscreen: function () {
      this.updateFullscreen(true)
      this.$emit('fullscreen-click')
    },
    forward: function () {
      this.$emit('forward')
    },
    back: function () {
      this.$emit('back')
    },
    download: function () {
      this.$emit('download')
    },
    showFormLetterPanel: function () {
      this.$emit('form-letter')
    },
    copyCurrentUrl: function () {
      this.$emit('copy-url')
    },
    addImage: function () {
      this.$emit('add-image')
    },
  },
}
</script>

<style scoped>
.ui.attached.secondary.segment {
  border: none;
  display: flex;
  justify-content: space-around;
  align-content: center;
  align-items: center;
  min-height: 3.1428571429rem;
}

.ui.button.group {
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
  flex-direction: row;
}

.ui.button.group:hover {
  background: transparent !important;
}

.viewer-control-panel_button {
  background: none;
  display: flex;
  justify-content: center;
  align-content: center;
  padding: 0 1.5rem 0 1.5rem;
}

.ui.button {
  background: none;
  display: flex;
  justify-content: center;
  align-content: center;
}

.hover {
  opacity: 0.85;
  transition: opacity 300ms ease-in, transform 300ms ease-out;
}

.hover:hover {
  opacity: 1;
  transform: scale(1.1);
  background: transparent !important;
}

.icon {
  color: #324057;
}

#loading-spinner {
  animation: spinner-spin infinite 1.0s ease-in-out;
}

@keyframes spinner-spin {
  0% {transform: rotate(180deg); }
  50% {transform: rotate(-180deg);}
  100% {transform: rotate(180deg); }
}

@media only screen and (max-width: 450px) {
  svg {
    font-size: 1.1em;
  }

  .ui.attached.secondary.segment {
    justify-content: center;
  }

  .ui.button.group {
    padding-left: 0em;
    padding-right: 0em;
  }

  .viewer-control-panel_button {
    padding: 0 .75rem 0 .75rem;
  }

  viewer-control-panel_plus-icon {
    font-size: .75rem;
  }
}
</style>
